<template>
    <div>
        <slot :data="cData" :loading="loading" :empty="empty"></slot>
        <infinite-loading :identifier="infiniteId" @infinite="infiniteHandler">
            <!-- <div slot="spinner">Loading...</div> -->
            <div slot="no-more" class="nomore_data">
                <span v-if="text != ''">{{text}}</span>
            </div>
            <div slot="no-results" class="noresult_data">
                <div v-if="keywords != ''">
                    <p>没有找到相关游戏</p>
                    <p>换个词搜搜看吧~</p>
                </div>
                <span v-else>{{nrtxt}}</span>
            </div>
            <div slot="error" class="result_error" slot-scope="{ trigger }">
                出错了，请刷新&nbsp;&nbsp;<a class="here" href="javascript:;" @click="trigger">here</a>
            </div>
        </infinite-loading>
    </div>
</template>

<script>
    import {
        debounce
    } from 'riku-verycloud'
    import InfiniteLoading from "vue-infinite-loading";
    export default {
        name: "market-scroll",
        components: {
            InfiniteLoading,
        },
        data() {
            return {
                page: 1,
                data: [],
                loading: 0,
                infiniteId: 1,
                allData: [],
                totalPage: 0,
            };
        },
        //返回时要修改
        props: {
            text: {
                type: String,
                default: "暂无更多",
            },
            pagesize: {
                type: Number,
                default: 10,
            },
            url: {
                type: String,
                required: true,
            },
            params: {
                type: Object,
                default () {
                    return {};
                },
            },
            keywords: {
                type: String,
                default: ''
            },
            nrtxt: {
              type: String,
              default: "暂无数据",
            },
            computeData: Function,
            method: {
                type: String,
                default: "post",
            }
        },
        computed: {
            sendData() {
                return {
                    ...this.params,
                    page: this.page,
                    pagesize: this.pagesize,
                };
            },
            trigger() {
                return this.url + "?" + this.$QueryString.stringify(this.params);
            },
            cData() {
                return (
                    (typeof this.computeData === "function" ?
                        this.computeData(this.data) :
                        this.data) || []
                );
            },
            empty() {
                return !this.cData.length;
            },
        },
        methods: {
            fuzzyQuery(list,keywords) {
                var arr = []
                for(var i = 0; i < list.length; i++) {
                    if(list[i].app_name.indexOf(keywords) >= 0) {
                        arr.push(list[i])
                    }
                }
                return arr
            },
            group(arr, len) {
                let index = 0;
                let newarr = [];
                var search_arr = []
                if(this.keywords != '') {
                    search_arr = this.fuzzyQuery(arr,this.keywords)
                }else {
                    search_arr = arr
                }
                while (index < search_arr.length) {
                    newarr.push(search_arr.slice(index, index += len))
                }
                return newarr
            },
            infiniteHandler: debounce(function ($state) {
                this.loading++;
                if (this.page == 1) {
                    this.$Ajax(this.url, this.sendData, this.method).then(rs => {
                        this.page++
                        if (rs.code == 200) {
                            this.allData = this.group(rs.data, this.pagesize)
                            this.totalPage = this.allData.length
                            if (rs.data.length == 0 || this.allData.length == 0) {
                                $state.complete();
                            } else {
                                this.data.push(...this.allData[0])
                                $state.loaded();
                            }
                            this.$emit("on-fetch", this.data[0]);
                        }
                    })
                } else {
                    if (this.page > this.totalPage) {
                        $state.complete();
                    } else {
                        this.data.push(...this.allData[this.page - 1])
                        $state.loaded();
                        this.page++
                    }
                }

            }),
            refresh() {
                this.page = 1;
                this.data = [];
                this.infiniteId++;
            },
        },
        watch: {
            trigger: "refresh"
        },
    };
</script>

<style lang="less" scoped>
    .nomore_data,
    .noresult_data,
    .result_error {
        color: #aaa;
        font-size: 1.4rem;
        padding: 1rem 0;

        .van-divider {
            margin: 0;
            font-size: 1.2rem;
            line-height: unset;
        }

        .van-icon-warning {
            font-size: 1.4rem;
            margin-right: 0.6rem;
        }

        .here {
            color: var(--theme);
        }
    }

    .choose_qf {
        padding: 0 1.2rem;
        height: 3.2rem;
        font-size: 1.2rem;
    }
</style>